import {
    Box,
    Grid,
    TextField,
    Typography
} from "@mui/material";
import * as React from "react";
import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {translate} from "../../../translate/translate";
import TableActionComponent from "../../../components/table/table-action.component";
import TablePaginationComponent from "../../../components/table/table-pagination.component";
import {ErrorComponent} from "../../../components/error/error.component";
import {PaginatedResult} from "../../../models/default/paginated-result";
import {useEffect} from "react";
import {Field, Form, Formik} from "formik";
import {useFilters} from "../../../filters/base-filter";
import {usePagination} from "../../../utils/pagination";
import {FtBomFilter, FtBomService} from "../../../services/ft-bom-service";
import {FtBom} from "../../../models/basic/ft-bom";
import { toast } from "react-toastify";
import {FtBomGroupService} from "../../../services/ft-bom-group-service";

const AssociateMaterialsComponent = (props: any) => {
    const {
        openDialog,
        handleCloseDialog,
        isDisabled,
        group,
    } = props;

    const [selectedMaterials, setSelectedMaterials] = React.useState<FtBom[]>([]);
    const serviceMaterials = new FtBomService();
    const service = new FtBomGroupService();
    
    const {filters, updateFilter, resetFilters } = useFilters<FtBomFilter>({search: "", associated: "false"}, []);
    const [materialsList, setMaterialsList] = React.useState<PaginatedResult<FtBom>>();
    const {
        dataSource,
        pagination,
        resetPage,
        handleChangePage,
        handleChangeRowsPerPage
    } = usePagination<FtBom>(materialsList);

    useEffect(() => {
        openDialog && loadMaterials();
        openDialog && resetPage();
    }, [openDialog]);

    const loadMaterials = (restartIndex = false) => {
        const newFilters = {...filters};
        serviceMaterials.listMaterials(newFilters, [], pagination).then(response => {
            setMaterialsList(response.data);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
        restartIndex && resetPage();
    };

    useEffect(() => {
        loadMaterials();
    }, [pagination, filters.search]);

    const handleRowSelect = (row: FtBom) => {
        const index = selectedMaterials.findIndex(item => item.foxconn_part_number === row.foxconn_part_number);
        if (index === -1) {
            setSelectedMaterials([...selectedMaterials, row]);
        } else {
            setSelectedMaterials(selectedMaterials.filter(item => item.foxconn_part_number !== row.foxconn_part_number));
        }
    }

    const handleSubmit = (materials: FtBom[]) => {
        service.associateGroup(group.id, materials).then(response => {
            toast.success(translate.t("successfully_updated"));
            setSelectedMaterials([]);
            resetFilters();
            resetPage();
            handleCloseDialog(true);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    }

    return (
        <GenericDialog
            open={openDialog}
            onClose={() => {
                setSelectedMaterials([]);
                updateFilter("search", "");
                handleCloseDialog();
            }}
            title={"associate_materials"}
            colorButton={"primary"}
            labelButton={"associate_btn"}
            maxWidth={"md"}
            disableConfirm={isDisabled || !selectedMaterials.length}
            handleConfirm={() => handleSubmit(selectedMaterials)}>
            <Box>
                <Typography style={{
                    fontWeight: 'bold',
                    marginBottom: '20px'}}>
                    {group.code + ' - ' + group.description}
                </Typography>
                <Formik
                    enableReinitialize={true}
                    validateOnMount={true}
                    initialValues={{search: ""}}
                    onSubmit={(values, {setSubmitting}) => {
                        setTimeout(() => {
                            loadMaterials(true);
                            setSubmitting(false);
                        }, 500);
                    }}
                >
                    {
                        () => (
                            <Form autoComplete="off">
                                <Grid alignItems="center" container spacing={2} direction={"row"} width="70%">
                                    <Grid >
                                        <Field
                                            as={TextField}
                                            name="search"
                                            label={""}
                                            fullWidth
                                            size="small"
                                            variant={"outlined"}
                                            autoFocus={true}
                                            placeholder={translate.t("search_ft_bom")}
                                            value={filters.search}
                                            onChange={(event: React.ChangeEvent<{
                                                value: string
                                            }>) => {
                                              resetPage();
                                              updateFilter("search", event.target.value)}
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                </Formik>
                <Box style={{marginTop: '0.5rem'}}>
                    <TablePaginationComponent
                        state={dataSource}
                        displayedColumnsShow={["", "FOXCONN PN", "description_en", "description_pt"]}
                        displayedColumns={["isRowSelectable", "foxconn_part_number", "description_english", "description_portuguese"]}
                        count={materialsList?.count}
                        next={materialsList?.next}
                        previous={materialsList?.previous}
                        page={pagination.page}
                        onPageChange={handleChangePage}
                        rowsPerPage={pagination.limit}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        actionsComponent={TableActionComponent}
                        columnStyles={{1:"2%", 2:"22%", 3:"38%", 4:"38%"}}
                        rowsPerPageOptions={[10, 50, 100]}
                        selectedRows={selectedMaterials}
                        selectedField={"foxconn_part_number"}
                        handleRowSelect={handleRowSelect}
                    />
                </Box>
            </Box>
        </GenericDialog>
    )
}

export default AssociateMaterialsComponent;
